import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import {
  BalanceSheetStateValues,
  updateKey,
  updateFieldArrayKey,
} from './slice';
import { requiredFiles } from '../../useValidateQuestionnaire';

export const fields: IBaseField<keyof BalanceSheetStateValues | any>[] = [
  {
    name: 'whichSoftwareDidYouUseToPrepareYourBookkeepingThisYear',
    label: 'Which Software did you use to prepare your bookkeeping this year?',
    type: 'select',
    options: [
      {
        label: 'ClientBooks',
        value: 'ClientBooks',
      },
      {
        label: 'QuickBooks Desktop',
        value: 'QuickBooks Desktop',
      },
      {
        label: 'QuickBooks Online',
        value: 'QuickBooks Online',
      },
      {
        label: 'Wave',
        value: 'Wave',
      },
      {
        label: 'Spreadsheet',
        value: 'Spreadsheet',
      },
      {
        label: 'Other',
        value: 'Other',
      },
    ],
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'other',
        label: 'Other',
        type: 'text',
        effect: updateKeyInStore(updateKey),
        comment: true,
        predicate: (v) => v === 'Other',
      },
    ],
  },

  {
    name: 'didYouReconcileYourBusinessBankAccounsAndCreditCardAccounts',
    label:
      'Did you reconcile your business bank accouns and credit card accounts?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'doYouHaveABalanceSheetPreparedForYourBusinessForYear',
    label: 'Do you have a Balance Sheet Prepared for your Business for {year}?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'pleaseUploadYourBalanceSheet',
        label: 'Please upload your balance sheet.',
        type: 'upload',
        effect: updateKeyInStore(updateKey),
        comment: true,
        predicate: (v) => v === 'yes',
      },
      {
        name: 'pleaseListYourBusinessAssetBalancesAsOfDecember31Year',
        label:
          'Please list your business asset balances as of December 31, {year}',
        type: 'fieldArray',
        dependencies: [
          {
            name: 'descriptionOfBankAccount',
            label: 'Description of Bank Account',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'balanceAtDecember31Year',
            label: 'Balance at December 31, {year}',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
        ],
        defaultDependency: {},
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        predicate: (v) => v === 'no',
        comment: true,
      },
      {
        name: 'didYouHaveAnyOtherBusinessAssetsThatYouHaveNotAlreadyListedAsOfDecember31Year',
        label:
          'Did you have any other business assets that you have not already listed as of December 31, {year}?',
        type: 'radio',
        effect: updateKeyInStore(updateKey),
        comment: true,
        predicate: (v) => v === 'no',
      },
      {
        name: 'businessAssets',
        label: 'Business Assets',
        type: 'fieldArray',
        dependencies: [
          {
            name: 'description',
            label: 'Description',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'dateOfPayment',
            label: 'Date of payment',
            type: 'date',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'amount',
            label: 'Amount',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
        ],
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        predicate: (v) => v === 'yes',
      },
    ],
  },
  {
    name: 'didYouHaveAnyBusinessLiabilitiesAsOfDecember31YearIncludingCreditCardsLoansAndPayrollTaxLiabilties',
    label:
      'Did you have any business liabilities as of December 31, {year}, including credit cards, loans, and payroll tax liabilties?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'businessLiabilities',
        label: 'Business Liabilities',
        type: 'fieldArray',
        dependencies: [
          {
            name: 'decription',
            label: 'Decription',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'amount',
            label: 'Amount',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
        ],
        defaultDependency: {},
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        predicate: (v) => v === 'yes',
        comment: true,
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
